import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { ResponseStatus } from 'app/modules/common/enums/common-enums';
import { PageLoaderService } from 'app/modules/common/services/page-loader.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { AudioStatus, Recording } from '../../entities/recordings.model';
import { RecordingsService } from '../../services/recordings.service';

@Component({
    selector: 'app-recordings-panel',
    templateUrl: './recordings-panel.component.html',
    styleUrls: ['./recordings-panel.component.scss'],
    standalone: false
})
export class RecordingsPanelComponent implements OnInit {
    public isLoading = false;
    public recordingsList = new Array<Recording>();
    public displayedColumns: string[] = [
        'link',
        'fecha',
        'telefono',
        'duracion',
        'buttons',
    ];
    public audioStatus = AudioStatus;
    public currentAudioFile: HTMLAudioElement;

    constructor(
        private recordingsService: RecordingsService,
        private sharedService: SharedService,
        private dialog: MatDialog,
        public pageLoaderService: PageLoaderService
    ) {}

    ngOnInit(): void {
        this.refresh();
        this.recordingsService.recordMatched.subscribe((matched) => {
            if (matched) {
                this.refresh();
            }
        });
    }

    public refresh(): void {
        this.refreshDataSource();
    }

    private refreshDataSource(): void {
        this.isLoading = true;
        this.recordingsService.isMatching = false;
        this.recordingsService.refreshRecordings().subscribe(
            (res) => {
                if (res.code == ResponseStatus.Success) {
                    this.recordingsList = this.recordingsService.mapRecordings(
                        res.result
                    );
                }
                this.isLoading = false;
            },
            (error) => {
                console.error(error);
                this.isLoading = false;
                this.sharedService.ShowSnackBar(
                    'Error en la carga de grabaciones'
                );
            }
        );
    }

    private delete(id: number): void {
        this.recordingsService.isMatching = false;
        this.recordingsService.deleteRecordings(id).subscribe(
            (res) => {
                if (res.code == ResponseStatus.Success && res.result) {
                    this.sharedService.ShowSnackBar(
                        'La grabación se ha eliminado'
                    );
                    this.refreshDataSource();
                } else {
                    this.sharedService.ShowSnackBar(
                        'Error al eliminar la grabación'
                    );
                }
            },
            (error) => {
                console.error(error);
                this.sharedService.ShowSnackBar(
                    'Error al eliminar la grabación'
                );
            }
        );
    }

    public deleteRecording(id: number): void {
        const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
            data: new ConfirmDialogModel(
                'Confirmar acción',
                '¿Eliminar la grabación?'
            ),
        });
        confirmDialog.afterClosed().subscribe((response) => {
            if (response) {
                this.delete(id);
            }
        });
    }

    public importRecordings(): void {
        this.recordingsService.isMatching = false;
        this.pageLoaderService.ShowPageLoader();
        this.recordingsService.importRecordings().subscribe(
            (res) => {
                if (res.code == ResponseStatus.Success) {
                    this.sharedService.ShowSnackBar(res.result);
                    this.refreshDataSource();
                } else {
                    this.sharedService.ShowSnackBar(
                        'Error al importar grabaciones'
                    );
                    console.error(res.message);
                }
                this.pageLoaderService.HidePageLoader();
            },
            (error) => {
                console.error(error);
                this.sharedService.ShowSnackBar(
                    'Error al importar grabaciones'
                );
                this.pageLoaderService.HidePageLoader();
            }
        );
    }

    public linkRecordings(): void {
        this.recordingsService.isMatching = false;
        this.pageLoaderService.ShowPageLoader();
        this.recordingsService.linkRecordings().subscribe(
            (res) => {
                const count =
                    res.code == ResponseStatus.Success ? res.result : 0;
                this.sharedService.ShowSnackBar(
                    `${count} grabaciones enlazadas`
                );
                this.pageLoaderService.HidePageLoader();
                this.refresh();
            },
            (error) => {
                console.error(error);
                this.sharedService.ShowSnackBar('Error al enlazar grabaciones');
                this.pageLoaderService.HidePageLoader();
            }
        );
    }

    public toggleLinking(recording: Recording, isMatching: boolean) {
        recording.isMatching = isMatching;
        this.recordingsService.isMatching = isMatching;
        this.recordingsService.recordToMatch = recording;
    }

    public syncAudio(id: number, status: AudioStatus): void {
        if (this.currentAudioFile) {
            this.currentAudioFile.pause();
            this.recordingsList.forEach((recording) => {
                recording.isPlaying = false;
            });
        }

        if (status === AudioStatus.Play) {
            this.pageLoaderService.ShowPageLoader();
            this.recordingsService.getAudioFile(id).subscribe(
                (res) => {
                    if (res.code === ResponseStatus.Success && res.result) {
                        this.currentAudioFile = new Audio(
                            `data:audio/mp3;base64,${res.result}`
                        );
                        this.currentAudioFile.currentTime = 0;
                        this.currentAudioFile.play();

                        this.recordingsList.filter(
                            (e) => e.grabacionId === id
                        )[0].isPlaying = true;
                    } else {
                        this.sharedService.ShowSnackBar(
                            'No está disponible el reproductor de audio'
                        );
                    }
                    this.pageLoaderService.HidePageLoader();
                },
                (error) => {
                    console.error(error);
                    this.sharedService.ShowSnackBar(
                        'No está disponible el reproductor de audio'
                    );
                    this.pageLoaderService.HidePageLoader();
                }
            );
        }
    }
}
